<template>
  <div>
    <div class="clearfix mt-3 mb-3">
      <div class="page-title float-left">
        <mdb-badge> 태도 평가 채점</mdb-badge>
        <span > {{test.name}}</span>
        <span v-if="test.name != test.code"> / {{test.code}} </span>
      </div>
      <div class="float-right">
        <mdb-btn class="p-2" icon="undo" @click="onBack">목록</mdb-btn>
        <mdb-btn class="p-2" icon="save" color="primary" @click="onSave">저장</mdb-btn>
        <mdb-btn v-if="isStaff" class="p-2" icon="trash" color="danger" @click="onDelete">삭제</mdb-btn>
      </div>
    </div>
    <div v-if="answer">
      <div class="sub-title">점수: {{answer.score}} 점</div>
      <mdb-tbl v-for="(q, qi) in test.evals" :key="qi" sm>
        <mdb-tbl-head>
          <tr>
            <th class="title bolder"><mdb-icon  icon="chalkboard-teacher" />  {{q.category}}</th>
            <th style="width:50px">점수</th>
          </tr>
        </mdb-tbl-head>
        <mdb-tbl-body >
          <tr v-for="(i, ix) in q.items" :key="ix">
            <td>{{i.text}}</td>
            <td v-if="answer.evals">
              <select class="select-underline" v-model="answer.evals[qi].scores[ix]"
                @change="onChange">
                <option>하</option>
                <option>중</option>
                <option>상</option>
              </select>
            </td>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>
      <div class="title bolder underline"><mdb-icon far icon="comment-alt" /> 강사의견</div>
      <mdb-input type="textarea" class="mt-2" v-if="answer" v-model="answer.comment" :rows="4"/>
    </div>
    <div class="text-right">
      <mdb-btn class="p-2" icon="undo" @click="onBack">목록</mdb-btn>
      <mdb-btn class="p-2" icon="save" color="primary" @click="onSave">저장</mdb-btn>
      <mdb-btn v-if="isStaff" class="p-2" icon="trash" color="danger" @click="onDelete">삭제</mdb-btn>
    </div>
  </div>
</template>
<script>
import { mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import AttitudeTest from '@/models/test/AttitudeTest'
import AttitudeTestAnswer from '@/models/test/AttitudeTestAnswer'
export default {
  components: { mdbTbl, mdbTblHead, mdbTblBody },
  name: 'StaffAttitudeTestView',
  props: [],
  data: () => ({
    test: {},
    answer: {}
  }),
  computed: {
    ...mapGetters('training', ['teacher', 'failScore']),
    ...mapGetters('auth', ['isStaff'])
  },
  methods: {
    onBack () {
      this.$router.back()
    },
    async onSave () {
      if (!confirm('저장할까요?')) return
      if (!this.answer.score) {
        this.answer.mark()
      }
      this.answer = await this.answer.save()
    },
    onChange () {
      this.answer.mark()
    },
    onDelete () {
      if (!confirm('삭제할까요?')) return
      this.answer.delete()
      this.$router.back()
    }
  },
  async created () {
    const { test, answer, student } = this.$route.query
    this.test = await AttitudeTest.get(test)
    if (answer) {
      this.answer = await AttitudeTestAnswer.get(answer)
      if (!this.answer) {
        this.answer = AttitudeTestAnswer.create(this.test, this.teacher, student)
      }
    } else {
      this.answer = AttitudeTestAnswer.create(this.test, this.teacher, student)
      this.answer.score = 100
      console.log(this.answer)
    }
  }
}
</script>
